import BehaviorOperand from './behavior_operand';

export default class BehaviorFieldOperand extends BehaviorOperand {
	_fieldId;
	_gridId;
	_property;

	constructor(props = {}) {
		super(props);
	}

	get fieldId() {
		return this._fieldId;
	}

	set fieldId(value) {
		this._fieldId = value;
	}

	get gridId() {
		return this._gridId;
	}

	set gridId(value) {
		this._gridId = value;
	}

	get property() {
		return this._property;
	}

	set property(value) {
		this._property = value;
	}
}
